import React, { useEffect, useRef, useState } from "react";
import "./NotifyDropdown.css";
import * as FeatherIcon from "react-feather";


const users = [
  { id: 1, name: "John Doe", email: "john@email.com" },
  { id: 2, name: "Jane Smith", email: "jane@email.com" },
  { id: 3, name: "Emily Johnson", email: "emily@email.com" },
  { id: 4, name: "Michael Brown", email: "michael@email.com" },
  { id: 5, name: "Sarah Davis", email: "sarah@email.com" },
];

const NotifyDropdown = ({ isOpen, onClose, anchorRef }) => {
  const popupRef = useRef(null);
  const [selected, setSelected] = useState([]);
  const [search, setSearch] = useState("");

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        popupRef.current &&
        !popupRef.current.contains(e.target) &&
        !anchorRef.current.contains(e.target)
      ) {
        onClose();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [onClose, anchorRef]);

  const toggleSelect = (id) => {
    setSelected((prev) =>
      prev.includes(id) ? prev.filter((i) => i !== id) : [...prev, id]
    );
  };

  const filteredUsers = users.filter(
    (u) =>
      u.name.toLowerCase().includes(search.toLowerCase()) ||
      u.email.toLowerCase().includes(search.toLowerCase())
  );

  if (!isOpen) return null;

  return (
    <div className="notify-popup" ref={popupRef}>
      <div className="notify-header">Share report</div>
      <div className="search_notify">
      <input
        type="text"
        className="notify-search"
        placeholder="Search from name / email"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />
        <FeatherIcon.Search className='search_icon_notify'/>
        </div>
      <div className="notify-subheader">
        {selected.length}/10 selected
      </div>
      <div className="notify-list">
        {filteredUsers.map((user) => (
          <label key={user.id} className="notify-item">
            <input
              type="checkbox" className="checkbox_notify"
              checked={selected.includes(user.id)}
              onChange={() => toggleSelect(user.id)}
            />
            
            <div className="avatar">{user.name.split(" ").map(n => n[0]).join("")}</div>
            <div className="info">
              <div className="name">{user.name}</div>
              <div className="email">{user.email}</div>
            </div>
          </label>
        ))}
      </div>
      <div className="notify-footer">
        <button className="notify-button">Notify <FeatherIcon.Send className='send_icon_notify'/></button>
      </div>
    </div>
  );
};

export default NotifyDropdown;